import { OrganizationCard } from "@/components/cards";
import { Divider } from "@msuite/ui/divider";
import { ColoredIcon, Icon } from "@msuite/ui/icons";
import { PlanStateTag, WorkspaceTag } from "@msuite/ui/tag";
import { TimelineItem } from "@msuite/ui/timeline";
import { Tooltip } from "@msuite/ui/tooltip";
import { filterNonNull } from "@msuite/utils/array";
import { getAddressString } from "@msuite/utils/strings";
import type { PartnerTimelineAssignmentReference } from "@msuite/utils/types";
import { CalculationTypeSelector } from "./calculation-type-selector";
import { AssignmentReferenceBookings } from "./partner-timeline-assignment-reference-bookings";
import { PartnerTimelineAssignmentReferenceServiceCalculation } from "./partner-timeline-assignment-reference-service-calculation";

/** Props Interface */
interface PartnerTimelineAssignmentReferenceItemProps {
	item: PartnerTimelineAssignmentReference;
	partnershipId: string;
}

export function PartnerTimelineAssignmentReferenceItem({
	item,
	partnershipId,
}: PartnerTimelineAssignmentReferenceItemProps) {
	/** Props */
	const referenceId = item.id;

	/** Render */
	return (
		<TimelineItem state={item.planState}>
			<div className="v-stack col-span-2">
				<div className="justify-between h-stack">
					<div className="h-stack">
						<OrganizationCard
							orgId={item.crew.orgId}
							withAvatar={false}
							withPopover={false}
							suffix={item.crew.ranking}
							fontSize="md"
							fontWeight="semibold"
						/>
						<Icon name="ArrowRight" />
						<OrganizationCard
							orgId={item.hostOrgId}
							withAvatar={false}
							withPopover={false}
							fontSize="md"
							fontWeight="semibold"
						/>
					</div>
					<div className="h-stack">
						<PlanStateTag state={item.planState} />
					</div>
				</div>
				<Divider
					variant="card"
					className="col-span-2 my-1"
				/>
				<div className="col-start-2">
					<WorkspaceTag workspace={item.project.workspace} />
					<div className="justify-between h-stack">
						<div className="h-stack">
							<p>{filterNonNull([item.project.name, item.project.number]).join(" / ")}</p>
						</div>
						<CalculationTypeSelector item={item} />
					</div>
					<p>{getAddressString(item.project)}</p>
				</div>
				<Divider
					variant="card"
					className="col-span-2 my-1"
				/>
				{item.ticketAssignments.map((assignment) => (
					<div
						className="h-stack"
						key={assignment.id}
					>
						<Tooltip label={assignment._ticket._ticketType?.name}>
							<ColoredIcon
								className="cursor-pointer"
								iconName={assignment._ticket._ticketType?.icon}
								color={assignment._ticket._ticketType?.color}
							/>
						</Tooltip>
						<p>{assignment._ticket.description}</p>
						<div className="flex-1" />
						<p className="label">{assignment._ticket.number}</p>
					</div>
				))}
				<Divider variant="card" />
				{item.reference.calculationType === "hourly" ? (
					<AssignmentReferenceBookings
						referenceId={referenceId}
						partnershipId={partnershipId}
						reference={item.reference}
						date={item.date}
						hostOrgId={item.hostOrgId}
					/>
				) : (
					<PartnerTimelineAssignmentReferenceServiceCalculation
						referenceId={referenceId}
						partnershipId={partnershipId}
						reference={item.reference}
						hostOrgId={item.hostOrgId}
					/>
				)}
			</div>
		</TimelineItem>
	);
}
